import { memo } from 'react';

import CSVIconSVG from '@/assets/csv-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICSVIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CSVIconSVG} {...props} />;

export const CSVIcon = memo(ICSVIcon) as typeof ICSVIcon;
